import { Box } from "@mui/material";
import { useState } from "react";
import httpClient from "../utils/httpClient";

const UpdateStorePage = () => {

    const [field, setField] = useState('');
    const [value, setValue] = useState('');
    const [type, setType] = useState('');
    const [id, setId] = useState('');

    const handleEntityType = (e) => {
        console.log(e.target.value);
        setType(e.target.value);
    }

    const handleValue = (e) => {
        console.log(e.target.value);
        setValue(e.target.value);
    }

    const handleId = (e) => {
        console.log(e.target.value);
        setId(e.target.value);
    }

    const handleField = (e) => {
        console.log(e.target.value);
        setField(e.target.value);
    }

    const handleSend = async () => {
        const resp = await httpClient.post(`/updateEntity`, {
            type, field, value, id
        });

        console.log('from server', resp);
    }
  
    return (
        <Box display="flex" flexDirection="column" gap={2} width='100%' padding='10px 30px'>
            <select value={type} onChange={handleEntityType}>
                <option value='task'>Task</option>
                <option value="patrol">Patrol</option>
            </select>
            Id: <input type="text" onChange={ handleId } size="100" value={id} />
            Field: <input type="text" onChange={handleField} size="100" value={field} />
            Value: <input type="text" onChange={handleValue} size="100" value={value} />
            <input type="submit" onClick={handleSend} />
        </Box>
    );
};

export default UpdateStorePage;

